import React from "react";
import { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { useAirtable } from "../hooks/useAirtable";
import { useIframe } from "../hooks/useIframe";
import { useMediaQuery } from "react-responsive";
function Search({ category, domain }) {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [title, setTitle] = useState("개인신청");
  const { fetchData } = useAirtable(category);
  const { setMoveUrl } = useIframe(domain);
  const isMobile = useMediaQuery({ maxWidth: 820 });
  useEffect(() => {
    setTitle(
      category === "individual"
        ? "개인신청"
        : category === "group"
        ? "단체신청"
        : category === "club"
        ? "대항전신청"
        : "개인신청"
    );
  }, []);

  const formatPhoneNumber = (value) => {
    const MAX_PHONE_LENGTH = 13; // "XXX-XXXX-XXXX" is 13 characters

    // Step 1: Remove any non-digit characters
    const numbers = value.replace(/[^\d]/g, "");

    // Step 2: Take the first 11 digits (if there are more)
    const trimmedNumbers = numbers.slice(0, 11);

    // Step 3: Divide the number string into 3-4-4
    const match = trimmedNumbers.match(/^(\d{3})(\d{4})(\d{4})$/);

    if (match) {
      const formattedNumber = `${match[1]}-${match[2]}-${match[3]}`;
      return formattedNumber.slice(0, MAX_PHONE_LENGTH); // ensure that the final string doesn't exceed the maximum length
    }

    return value; // if it doesn't match the pattern, return the original value
  };

  const handlePhoneNumberChange = (event) => {
    // Extract the value from the event object
    const rawValue = event.target.value;

    // Format the phone number
    const formattedValue = formatPhoneNumber(rawValue);

    // Update the state with the formatted value
    setPhoneNumber(formattedValue);
  };

  const handleSubmit = async () => {
    try {
      const { fields, id } = await fetchData(
        `AND({name}="${name}", {password}="${password}", {phoneNumber}="${phoneNumber}")`
      );

      // Check if data exists
      if (fields) {
        let pathName = "";
        if (category === "individual") {
          pathName = "indiv";
        } else if (category === "group") {
          pathName = "team";
        } else if (category === "club") {
          pathName = "competition";
        }
        setMoveUrl(
          `${domain}/${pathName}?mode=edit&name=${name}&password=${password}&phoneNumber=${phoneNumber}`
        );
      } else {
        // If no data is found, show an alert
        alert("이름 또는 비밀번호 다시 확인해주세요🙏");
      }
    } catch (error) {
      console.error("Error while handling submit:", error);
    }
  };

  return (
    <Container ismobile={isMobile}>
      <Title ismobile={isMobile}>{title} 확인</Title>
      <FormContainer>
        <FormWrapper ismobile={isMobile}>
          {category === "individual" && (
            <>
              <FormKey ismobile={isMobile}>
                성명 <b>*</b>
              </FormKey>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="성명"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </>
          )}
          {category !== "individual" && (
            <>
              <FormKey ismobile={isMobile}>
                단체명 <b>*</b>
              </FormKey>
              <div id="value">
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="단체명"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </div>
            </>
          )}
        </FormWrapper>
        <FormWrapper ismobile={isMobile}>
          <FormKey ismobile={isMobile}>
            전화번호 <b>*</b>
          </FormKey>
          <div id="value">
            <input
              type="tel"
              id="phoneNumber"
              name="phoneNumber"
              placeholder="010-0000-000"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
            />
          </div>
        </FormWrapper>
        <FormWrapper ismobile={isMobile}>
          <FormKey ismobile={isMobile}>
            비밀번호 <b>*</b>
          </FormKey>
          <div id="value">
            <input
              type="password"
              id="password"
              name="password"
              placeholder="비밀번호"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            <input type="button" value={"검색"} onClick={handleSubmit} />
          </div>
        </FormWrapper>
      </FormContainer>
    </Container>
  );
}

export default Search;

const Container = styled.div`
  width: ${(props) => (props.ismobile ? "90%" : "82%")};
  margin: 0 auto;
  padding: 5rem 0;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  & input[type="text"],
  input[type="tel"],
  input[type="date"],
  input[type="email"],
  input[type="password"] {
    width: ${(props) => (props.ismobile ? "100%" : "30rem")};
    border: 1.2px solid #d9d9d9;
    margin-left: ${(props) => (props.ismobile ? "1rem" : "2rem")};
    padding: ${(props) => (props.ismobile ? "0.8rem" : "1.4rem")};
  }
  & input[type="button"] {
    padding: ${(props) => (props.ismobile ? "0.8rem 2rem" : "1.4rem 3.5rem")};
    border: 1.2px solid #d9d9d9;
    background: #d9d9d9;
    color: #4f4f4f;
    font-size: 1.5rem;
    font-weight: 700;
    letter-spacing: -0.2px;
    margin-left: ${(props) => (props.ismobile ? "1rem" : "2rem")};
    margin-top: ${(props) => (props.ismobile ? "1rem" : "0")};
    cursor: pointer;
  }
`;
const Title = styled.div`
  color: #555;
  font-family: "Jalnan", sans-serif;
  font-size: ${(props) => (props.ismobile ? "3rem" : "4rem")};
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: -0.8px;
  & b {
    color: #ff791a;
  }
`;
const FormContainer = styled.div`
  margin-top: 6rem;
  overflow: hidden;
  border-radius: 15px;
  border: 1.5px solid #d9d9d9;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const FormWrapper = styled.div`
  padding: ${(props) => (props.ismobile ? "1rem" : "3.5rem")};
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1.5px solid #d9d9d9;
  box-sizing: border-box;
  &:last-child {
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 0px solid #d9d9d9;
  }
  & > #value {
    display: flex;
    flex-wrap: wrap;
    flex-direction: ${(props) => (props.ismobile ? "column" : "row")};
  }
`;
const FormKey = styled.div`
  width: ${(props) => (props.ismobile ? "30%" : "20%")};
  flex-shrink: 0;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: ${(props) => (props.ismobile ? "1.5rem" : "1.7rem")};
  font-style: normal;
  font-weight: 800;
  line-height: 100%; /* 17px */
  letter-spacing: -0.2px;
  border-right: 1px solid #d9d9d9;
  flex-shrink: 0;
  & b {
    color: #d10000;
  }
`;
